// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MenuSearchAndFilter Component Styles */

.menu-search-filter-container {
  /* Container styles if needed */
}

.search-filter-controls {
  margin-bottom: 20px;
}

.search-filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.search-input-container {
  position: relative;
  width: 50%;
}

.search-input {
  width: 100%;
  padding: 10px 40px 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
}

.search-input:focus {
  border-color: #007bff;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 16px;
  pointer-events: none;
}

.version-tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.version-tab {
  padding: 12px 20px;
  border: none;
  border-bottom: 2px solid transparent;
  background-color: transparent;
  color: #666;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s ease;
  position: relative;
}

.version-tab.active {
  border-bottom: 2px solid rgb(159, 32, 137);
  color: rgb(159, 32, 137);
  font-weight: 600;
}

.results-summary {
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #666;
  font-weight: 500;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./client/components/common/MenuSearchAndFilter.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B","sourcesContent":["/* MenuSearchAndFilter Component Styles */\n\n.menu-search-filter-container {\n  /* Container styles if needed */\n}\n\n.search-filter-controls {\n  margin-bottom: 20px;\n}\n\n.search-filter-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.search-input-container {\n  position: relative;\n  width: 50%;\n}\n\n.search-input {\n  width: 100%;\n  padding: 10px 40px 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.search-input:focus {\n  border-color: #007bff;\n}\n\n.search-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #666;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n.version-tabs {\n  display: flex;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.version-tab {\n  padding: 12px 20px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background-color: transparent;\n  color: #666;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 400;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.version-tab.active {\n  border-bottom: 2px solid rgb(159, 32, 137);\n  color: rgb(159, 32, 137);\n  font-weight: 600;\n}\n\n.results-summary {\n  margin-top: 15px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  color: #666;\n  font-weight: 500;\n  padding: 8px 0;\n  border-top: 1px solid #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
